// extracted by css-extract-rspack-plugin
export default {"cls1":"DownloadHeroCard-cls1_saq","cls2":"DownloadHeroCard-cls2_gTn DownloadHeroCard-cls1_saq","fill-lightblue":"DownloadHeroCard-fill-lightblue_Wn0"};